(function($) {

  $(document).ready(function() {

    if ($().slick) {
      //var isSlickLoaded = (typeof $.fn.Slick !== 'undefined');
      //if (isSlickLoaded) {
      //if ($.fn.slick && $.fn.matchHeight) {
      // Slick is initialized

      // Match Height
      $('#brand-slider').slick({
        speed: 2000,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        slidesToShow: 6,
        slidesToScroll: 1,
        dots: false,
        arrows: false,

        responsive: [{
            breakpoint: 992,
            settings: {
              slidesToShow: 4,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
            }
          }
        ]
      });

    }

  });

})(jQuery);
